<div class="page-container">
    <div class="page-header">
        <button class="btn-back" (click)="location.back()">
            <mat-icon>arrow_back</mat-icon>
            <span>Back to Fleet</span>
        </button>
        <div class="header-content">
            <h1 class="page-title">{{ isEdit === 'true' ? 'Edit Truck' : 'New Truck Registration' }}</h1>
            <p class="page-subtitle">{{ isEdit === 'true' ? 'Update truck information and specifications' : 'Add a new truck to your fleet' }}</p>
        </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-overlay">
        <mat-spinner diameter="50" color="primary"></mat-spinner>
        <p class="loading-text">{{ isEdit === 'true' ? 'Updating truck...' : 'Registering truck...' }}</p>
    </div>

    <div class="form-card" [class.loading]="isLoading">
        <!-- Truck Specifications Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>local_shipping</mat-icon>
                </div>
                <div class="section-title">
                    <h2>Truck Specifications</h2>
                    <p>Basic truck details and configuration</p>
                </div>
            </div>

            <div class="form-grid">
                <div class="form-group">
                    <label class="form-label">Type of Truck</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-select [(value)]="truckTypeSelectedValue" [compareWith]="compareById">
                            <mat-option *ngFor="let option of truckTypeOptions" [value]="option">
                                {{ option.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Truck's Model</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-select [(value)]="truckModelSelectedValue"
                            [compareWith]="compareById"
                            panelClass="custom-select-panel"
                            (openedChange)="onTruckModelSelectOpened($event)">
                            <mat-option class="search-option">
                                <input
                                    type="text"
                                    placeholder="Search model..."
                                    [(ngModel)]="truckModelSearchText"
                                    (input)="filterTruckModelList()"
                                    (click)="$event.stopPropagation()"
                                    (mousedown)="$event.stopPropagation()"
                                    (keydown)="$event.stopPropagation()"
                                    class="search-input"
                                    autocomplete="off"
                                />
                            </mat-option>
                            <mat-option *ngFor="let option of filteredTruckModelOptions" [value]="option">
                                {{ option.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Year Made</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">calendar_today</mat-icon>
                        <mat-select [(value)]="yearMadeSelected" placeholder="Select year">
                            <mat-option [value]="null">-- Select Year --</mat-option>
                            <mat-option *ngFor="let year of yearMadeOptions" [value]="year">
                                {{ year }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="form-grid" style="grid-template-columns: repeat(3, 1fr);">
                <div class="form-group">
                    <label class="form-label">Plate Number</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">confirmation_number</mat-icon>
                        <input matInput [(ngModel)]="plateNumber" placeholder="Enter plate number" />
                    </mat-form-field>
                </div>
            </div>

            <div class="form-grid">
                <div class="form-group">
                    <label class="form-label">Truck Loading Capacity</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-select [(value)]="truckLoadCapacitySelectedValue" [compareWith]="compareById">
                            <mat-option *ngFor="let option of truckLoadCapacityOptions" [value]="option">
                                {{ option.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Box Size</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-select [(value)]="boxSizeSelectedValue" [compareWith]="compareById">
                            <mat-option *ngFor="let option of boxSizeOptions" [value]="option">
                                {{ option.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Box Loading Type</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-select [(value)]="boxLoadingTypeSelectedValue" [compareWith]="compareById">
                            <mat-option *ngFor="let option of boxLoadingTypeOptions" [value]="option">
                                {{ option.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="form-grid">
                <div class="form-group">
                    <label class="form-label">GPS</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">gps_fixed</mat-icon>
                        <mat-select [(value)]="gpsSelected">
                            <mat-option *ngFor="let option of gpsOptions" [value]="option">
                                {{ option.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Camera</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">videocam</mat-icon>
                        <mat-select [(value)]="cameraSelected">
                            <mat-option *ngFor="let option of cameraOptions" [value]="option">
                                {{ option.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Fuel Type</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">local_gas_station</mat-icon>
                        <mat-select [(value)]="fuelTypeSelected">
                            <mat-option *ngFor="let option of fuelTypeOptions" [value]="option">
                                {{ option.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="sub-section">
                <div class="sub-section-header">
                    <mat-icon class="sub-section-icon">verified_user</mat-icon>
                    <span>Vehicle Inspection Information</span>
                </div>
                <div class="form-grid" style="grid-template-columns: 1fr 1fr;">
                    <div class="form-group">
                        <label class="form-label">Engine Number</label>
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-icon matPrefix class="field-icon">settings</mat-icon>
                            <input matInput [(ngModel)]="engineNumber" placeholder="Enter engine number" />
                        </mat-form-field>
                    </div>

                    <div class="form-group">
                        <label class="form-label">Body-Chassis Number</label>
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-icon matPrefix class="field-icon">directions_car</mat-icon>
                            <input matInput [(ngModel)]="chassisNumber" placeholder="Enter chassis number" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="form-grid" style="grid-template-columns: 1fr 1fr;">
                    <div class="form-group">
                        <label class="form-label">Inspection Date</label>
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-icon matPrefix class="field-icon">fact_check</mat-icon>
                            <input matInput [(ngModel)]="inspectionDate" [matDatepicker]="inspectionPicker" placeholder="Select date" />
                            <mat-datepicker-toggle matIconSuffix [for]="inspectionPicker"></mat-datepicker-toggle>
                            <mat-datepicker #inspectionPicker></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div class="form-group">
                        <label class="form-label">Expiry Date</label>
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-icon matPrefix class="field-icon">event_busy</mat-icon>
                            <input matInput [(ngModel)]="inspectionExpiryDate" [matDatepicker]="expiryPicker" placeholder="Select date" />
                            <mat-datepicker-toggle matIconSuffix [for]="expiryPicker"></mat-datepicker-toggle>
                            <mat-datepicker #expiryPicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>

        <!-- Maintenance & Reports Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>build</mat-icon>
                </div>
                <div class="section-title">
                    <h2>Maintenance & Reports</h2>
                    <p>Maintenance records and incident tracking</p>
                </div>
            </div>

            <div class="form-grid" style="grid-template-columns: 1fr 1fr;">
                <div class="form-group">
                    <label class="form-label">Vehicle Maintenance</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-select [(value)]="vehicleSelectedValue" [compareWith]="compareById">
                            <mat-option *ngFor="let option of vehicleOptions" [value]="option">
                                {{ option.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Incident Report</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-select [(value)]="incidentReportSelectedValue" [compareWith]="compareById">
                            <mat-option *ngFor="let option of incidentReportOptions" [value]="option">
                                {{ option.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="form-grid" style="grid-template-columns: 1fr 1fr;">
                <div class="form-group">
                    <label class="form-label">Service Date</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">build_circle</mat-icon>
                        <input matInput [(ngModel)]="serviceDate" [matDatepicker]="servicePicker" placeholder="Select date" />
                        <mat-datepicker-toggle matIconSuffix [for]="servicePicker"></mat-datepicker-toggle>
                        <mat-datepicker #servicePicker></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Next Service Date</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">event_repeat</mat-icon>
                        <input matInput [(ngModel)]="nextServiceDate" [matDatepicker]="nextServicePicker" placeholder="Select date" />
                        <mat-datepicker-toggle matIconSuffix [for]="nextServicePicker"></mat-datepicker-toggle>
                        <mat-datepicker #nextServicePicker></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>

            <div class="form-grid" style="grid-template-columns: 1fr;">
                <div class="form-group">
                    <label class="form-label">Route Expertise</label>
                    <div class="route-expertise-container">
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-icon matPrefix class="field-icon">route</mat-icon>
                            <input
                                matInput
                                [formControl]="searchControl"
                                [matAutocomplete]="auto"
                                placeholder="Search route expertise"
                            />
                        </mat-form-field>
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addSelection($event.option.value)">
                            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                {{ option.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-chip-set class="chip-set">
                            <mat-chip *ngFor="let item of routeSelectedList" [removable]="true" (removed)="remove(item)">
                                {{ item.name }}
                                <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip>
                        </mat-chip-set>
                    </div>
                </div>
            </div>
        </div>

        <!-- Driver Selection Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>person</mat-icon>
                </div>
                <div class="section-title">
                    <h2>Driver Information</h2>
                    <p>Select a driver for this truck</p>
                </div>
            </div>

            <div class="form-grid">
                <div class="form-group">
                    <label class="form-label">Select Driver</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-select [(value)]="selectedDriver" (selectionChange)="onDriverSelect($event.value)"
                            panelClass="custom-select-panel"
                            (openedChange)="onDriverSelectOpened($event)">
                            <mat-option class="search-option" *ngIf="driverList.length > 0">
                                <input
                                    #driverSearchInput
                                    type="text"
                                    placeholder="Search by name or phone..."
                                    [(ngModel)]="driverSearchText"
                                    (input)="filterDriverList()"
                                    (click)="$event.stopPropagation()"
                                    (mousedown)="$event.stopPropagation()"
                                    (keydown)="$event.stopPropagation()"
                                    class="search-input"
                                    autocomplete="off"
                                />
                            </mat-option>
                            <mat-option *ngFor="let driver of filteredDriverList" [value]="driver">
                                {{ driver.englishName || driver.khmerName }} - {{ driver.primaryContactNumber | phoneFormat }}
                            </mat-option>
                            <mat-option class="no-driver-option" disabled *ngIf="driverList.length === 0">
                                <div class="no-driver-state">
                                    <mat-icon class="no-driver-icon">person_off</mat-icon>
                                    <p class="no-driver-title">No Available Drivers</p>
                                    <p class="no-driver-subtitle">All drivers are currently assigned or none are registered.</p>
                                </div>
                            </mat-option>
                            <mat-option class="no-driver-option" disabled *ngIf="driverList.length > 0 && filteredDriverList.length === 0">
                                <div class="no-driver-state">
                                    <mat-icon class="no-driver-icon">search_off</mat-icon>
                                    <p class="no-driver-title">No Matching Drivers</p>
                                    <p class="no-driver-subtitle">Try a different name or phone number.</p>
                                </div>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="form-group" *ngIf="selectedDriver">
                    <label class="form-label">Contact Number</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">phone</mat-icon>
                        <input matInput [value]="selectedDriver?.primaryContactNumber | phoneFormat" disabled />
                    </mat-form-field>
                </div>
            </div>
        </div>

        <!-- Truck Profile Picture Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>account_box</mat-icon>
                </div>
                <div class="section-title">
                    <h2>Truck Profile Picture</h2>
                    <p>Upload a profile photo for this truck</p>
                </div>
            </div>

            <div class="image-upload-container">
                <input
                    type="file"
                    accept=".png, .jpg, .jpeg"
                    (change)="onProfilePictureSelected($event)"
                    #profilePicInput
                    style="display: none"
                />
                <button type="button" class="btn-upload" (click)="profilePicInput.click()" [disabled]="!!truckProfilePicture">
                    <mat-icon>cloud_upload</mat-icon>
                    <span>Choose Image</span>
                </button>
                <span class="upload-hint">Only 1 image allowed: (.png, .jpg, .jpeg)</span>
                <div *ngIf="truckProfilePicture" class="image-preview-grid">
                    <div class="image-preview-item">
                        <img [src]="getImageUrl(truckProfilePicture)" alt="Truck Profile Preview" />
                        <button type="button" class="btn-remove-image" (click)="removeProfilePicture()">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Truck Picture Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>photo_camera</mat-icon>
                </div>
                <div class="section-title">
                    <h2>Truck Picture</h2>
                    <p>Upload photos of the truck</p>
                </div>
            </div>

            <div class="image-upload-container">
                <input
                    type="file"
                    accept=".png, .jpg, .jpeg"
                    multiple
                    (change)="onFileSelected($event)"
                    #fileInput
                    style="display: none"
                />
                <button type="button" class="btn-upload" (click)="fileInput.click()">
                    <mat-icon>cloud_upload</mat-icon>
                    <span>Choose Images</span>
                </button>
                <span class="upload-hint">Only images allowed: (.png, .jpg, .jpeg)</span>
                <div *ngIf="selectedFilesList.length > 0" class="image-preview-grid">
                    <div *ngFor="let file of selectedFilesList; let i = index" class="image-preview-item">
                        <img [src]="getImageUrl(file)" [alt]="'Truck Preview ' + (i + 1)" />
                        <button type="button" class="btn-remove-image" (click)="removeImage(i)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Insurance Information Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>shield</mat-icon>
                </div>
                <div class="section-title">
                    <h2>Insurance Information</h2>
                    <p>Insurance coverage details</p>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">Insurance Status</label>
                <mat-radio-group [(ngModel)]="hasInsuranceValue" class="radio-group">
                    <mat-radio-button *ngFor="let option of hasInsuranceoptions" [value]="option" class="radio-button">
                        {{ option.name }}
                    </mat-radio-button>
                </mat-radio-group>
            </div>

            <div class="form-grid" *ngIf="hasInsuranceValue.value">
                <div class="form-group">
                    <label class="form-label">Insurance Company</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">business</mat-icon>
                        <input matInput [(ngModel)]="insuranceCompany" placeholder="Enter insurance company" />
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Sum Insurance Amount</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">attach_money</mat-icon>
                        <input matInput [(ngModel)]="sumInsuranceAmount" placeholder="Enter insurance amount" (input)="onInsuranceAmountInput($event)" inputmode="decimal" />
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Type Insurance</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-select [(value)]="typeInsuranceSelectedValue" [compareWith]="compareById">
                            <mat-option *ngFor="let option of typeInsuranceOptions" [value]="option">
                                {{ option.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="form-grid" style="grid-template-columns: 1fr;">
                <div class="form-group">
                    <label class="form-label">Security Deposit Amount</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-select [(value)]="securityDepositeSelectedValue" [compareWith]="compareById">
                            <mat-option *ngFor="let option of securityDepositeAmountOptions" [value]="option">
                                {{ option.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <!-- Form Actions -->
        <div class="form-actions">
            <button type="button" class="btn-cancel" (click)="location.back()">
                Cancel
            </button>
            <button type="submit" class="btn-primary" (click)="submitButtonAction()">
                <mat-icon>{{ isEdit === 'true' ? 'save' : 'add' }}</mat-icon>
                <span>{{ isEdit === 'true' ? 'Update Truck' : 'Register Truck' }}</span>
            </button>
        </div>
    </div>
</div>
